import { BooleanDialogData } from './booleanDialogData';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'affinis-boolean-dialog',
  templateUrl: './boolean-dialog.component.html',
})
export class AffinisBooleanDialogComponent {
  /**
   * Creates a new instance of AffinisBooleanDialogComponent.
   * @param data - Data to be passed to the dialog for displaying the message.
   */
  public constructor(@Inject(MAT_DIALOG_DATA) public data: BooleanDialogData) {}
}
